module.exports = __webpack_public_path__ + "media/images/top/icon/black/ico_angle_right-4ecc57dfcaa09f064a373c9ee433993e.svg";